module.exports = __webpack_public_path__ + "img/v4.4f8c2b4d.png";